<template>
  <v-dialog :key="changeKey" v-model="dialog" @input="v => v || closeDialog()">
    <v-card-text class="modal-header">
      <v-img
        @click="closeDialog"
        class="cancel-image"
        src="../../assets/icons/cancel.png"
        height="15px"
        width="15px"
      />
      <div class="text-center py-3">
        <h3>{{ dialogTitle }}</h3>
      </div>
    </v-card-text>
    <v-card class="d-flex justify-content-center">
      <v-card-text v-if="systemsData && systemsData.system" class="content-modl">
        <div style="overflow-x: auto;">
                
          <table class="table table-bordered table-striped my-4" >
            <thead>
              <tr>
                <th>#</th>
                <th scope="col">{{ "lng_th_systemId" | translate }}</th>
                <th scope="col">{{ "lng_th_address" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_email" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_phone" | translate }}</th>
                <th scope="col">{{ "lng_th_mac_number_txt" | translate }}</th>
                <th scope="col">{{ "lng_th_service_contract_txt" | translate }}</th>
                <th scope="col" v-if="systemsData.system.rssi">{{ "lng_th_rssi" | translate }}</th>
                <th scope="col">{{ "lng_th_actions" | translate }}</th>

              </tr>
            </thead>
            <tbody>
              <tr>

                <td data-toggle="collapse" :data-target="`#collapsedRow${systemsData.system.id}`" class="accordion-toggle collapsed expand-button" @click="getHouseBoxes(systemsData.system)"></td>
                <th scope="row">{{ systemsData.system.id }}</th>
                <td>
                  {{systemsData.system | formatAddress}}
                </td>
                <td>{{ systemsData.system.alarmemail }}</td>
                <td>{{ systemsData.system.alarmsms }}</td>
                <td>{{ systemsData.system.mecnumber }}</td>
                <td>{{ systemsData.system.servicecontract == "1" ? "lng_yes_txt" : "lng_no_txt" | translate }}</td>
                <td>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <td v-bind="attrs" v-on="on" v-if="systemsData.system.rssi >= 1 && systemsData.system.rssi < 5 ">
                      <v-icon color="red">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 5  && systemsData.system.rssi < 7">
                      <v-icon color="orange">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 7  && systemsData.system.rssi <= 9">
                      <v-icon color="yellow">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 10  && systemsData.system.rssi <= 12">
                      <v-icon color="blue">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 13  && systemsData.system.rssi < 20">
                      <v-icon color="purple">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 20">
                      <v-icon color="green">mdi-antenna</v-icon>
                    </td>
                  </template>
                   <span>{{"lng_th_rssi" | translate}}:{{systemsData.system.rssi}}</span><br>
                    <span>{{"lng_th_rssi_date" | translate}}:{{systemsData.system.rssidate}}</span>
                </v-tooltip>
                </td>
                <td>
                    <div class="d-flex justify-content-center">
                        <v-btn
                          small
                          color="#0B7894"
                          dark
                          @click="openUpdateModal(systemsData.system)"
                        >{{ "lng_update_btn" | translate }}</v-btn>
                    </div>
                </td>
              
                <tr>
                  <td colspan="12" class="hiddenRow">
                    <div class="accordion-body collapse container-fluid" :id="`collapsedRow${systemsData.system.id}`">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>{{ "lng_th_boxType" | translate }}</th>
                            <th>{{ "lng_th_boxId" | translate }}</th>
                            <th>{{ "lng_th_boxPass" | translate }}</th>
                            <th>{{ "lng_th_actions" | translate }}</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ "lng_sewer_text" | translate }}</td>
                            <td>{{ systemsData.devices[0].id }}</td>
                            <td>{{ systemsData.devices[0].pincode }}</td>
                            <td>
                              <v-btn
                                small
                                color="#0B7894"
                                dark
                                @click="openReplaceBoxModal(systemsData.devices[0], systemsData.system.id)"
                              >{{ "lng_replace_btn" | translate }}</v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ "lng_house_text" | translate }}</td>
                            <td>{{ systemsData.devices[1].id }}</td>
                            <td>{{ systemsData.devices[1].pincode }}</td>
                            <td>
                              <v-btn
                                small
                                color="#0B7894"
                                dark
                                @click="openReplaceBoxModal(systemsData.devices[1], systemsData.system.id)"
                              >{{ "lng_replace_btn" | translate }}</v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <ShowExtraBoxes
                        v-if="findBoxes(systemsData.system)"
                        :extraHouseBoxes="extraHouseBoxes"
                        :systemId="systemsData.system.id"
                        :user-token="userToken"
                        @addNewHouseBox="addNewHouseBox"
                        @refreshHouseBoxes="refreshHouseBoxes"
                      />
                    </div>
                  </td>
                </tr>
              </tr>
            </tbody>
          </table>
          
        </div>

        <div>
          <v-select
              v-if="authLevel === '3'"
              class="dropdown-style"
              solo
              :items="filterDropdownData"
              v-model="selectedDealer"
              item-text="name"
              item-value="value"
              :label="'lng_th_assign_user_txt' | translate"
              return-object
              @change="assignDealer"
            >
              <template v-slot:selection="{ item, index }">
                <div :key="index" class="dropdown-list-item">
                  <span class="flags pl-1">{{ item.name }}</span>
                  <userRoles :roleKey="item.authlevel" templateType="chip"/>
                </div>
              </template>
              <template v-slot:item="{ item, index }">
                <div :key="index" class="dropdown-list-item">
                  <span class="flags pl-1">{{ item.name }}</span>
                  <userRoles :roleKey="item.authlevel" templateType="chip"/>
                </div>
              </template>
            </v-select>
        </div>
        <!-- Employee Select Start-->
       <!-- <div>
          <v-select
              v-if="authLevel === '0'"
              class="dropdown-style"
              solo
              :items="employeeData"
              v-model="selectedEmployee"
              item-text="name"
              item-value="id"
              label="Assign Employee"
              return-object
              @change="assignEmployeeToSystem"
            >
            </v-select>
        </div> -->
        <!-- Employee Select End-->

        <div>
          <v-data-table
            v-if="dealersData && dealersData.dealers"
            :headers="dealerTableHeaders"
            :items="dealersData.dealers"
            class="elevation-1"
          >
            <template v-slot:item.userType="{ item }">
              <userRoles :roleKey="item.authlevel" templateType="chip"/>
            </template>
            <template v-slot:item.full_address="{ item }">{{ item | formatAddress }}</template>
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" @click="removeDealer(item)"
                  fab x-small v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ "lng_delete_user_txt" | translate }}</span>
              </v-tooltip>
            </template>

          </v-data-table>
        </div>

      </v-card-text>

      <v-card-text v-else class="content-modl">
        <div class="text-center py-10">
          <v-progress-circular
            color="#0b7894"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card-text> 
    </v-card>
     <ReplaceBoxModal
      :box-id="replaceBoxId"
      :system-id="selectedSystemId"
      :user-token="userToken"
      :dialog-title="replaceBoxTitle"
      :openDialog="openReplaceBoxToggle"
      :closeDialog="closeReplaceBoxModalFunc"
      :addHouseBoxProp="addHouseBoxProp"
      @refreshHouseBoxes="refreshHouseBoxes"
      @updateLocalData="fetchSystemsData(userToken)"
    ></ReplaceBoxModal>
    <updateBoxAddress
      :changeKey="updateBoxKey"
      :complete-address="addressObj"
      :user-token="userToken"
      :dialog-title="'lng_update_box_txt' | translate"
      :openDialog="openUpdateBoxModal"
      :closeDialog="closeUpdateBoxModalFunct"
      @updateLocalData="fetchSystemsData(userToken)"
    ></updateBoxAddress>
  </v-dialog>
  
</template>

<script>
import GlobalService from "../../services/global-service";
import router from "../../router";
import { translateFunc } from '../../common/Filters';
import UserRoles from "./UserRoles";
import updateBoxAddress from "../../components/updateBoxAddress";
import ReplaceBoxModal from "../../components/ReplaceBoxModal";
import ShowExtraBoxes from "../../components/ShowExtraBoxes.vue";

export default {
  name: "SystemInfoModal",
  components: {
    UserRoles,
    updateBoxAddress,
    ReplaceBoxModal,
    ShowExtraBoxes,
  },
  data() {
    return {
      dialog: false,
      systemsData: undefined,
      dealersData: undefined,
      selectedDealer: undefined,
      selectedEmployee: undefined,
      authLevel: undefined,
      openBoxModal: false,
      userToken: undefined,
      openReplaceBoxToggle: false,
      replaceBoxTitle: "",
      addressObj: {},
      replaceBoxId: "",
      dealerTableHeaders: [
        { text: translateFunc('lng_th_user_type_txt'), value: 'userType', sortable: false, },
        { text: translateFunc('lng_th_email_txt'), value: 'email' },
        { text: translateFunc('lng_invoice_email_text'), value: 'invoiceemail' },
        { text: translateFunc('lng_th_name_txt'), value: 'name' },
        { text: translateFunc('lng_th_companyName_txt'), value: 'companyname' },
        { text: translateFunc('lng_th_cvr_txt'), value: 'cvr' },
        { text: translateFunc('lng_th_address_txt'), value: 'full_address' },
        { text: translateFunc('lng_th_lastActive_txt'), value: 'lastlogin' },
        { text: translateFunc('lng_th_actions'), value: 'action', sortable: false },
      ],
      extraHouseBoxes: [],
      addHouseBoxProp: false,
      selectedSystemId: "",
      updateBoxKey: 1,
      addressObj: {},
      openUpdateBoxModal: false,
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    systemData: {
      type: Object,
      default: () => {}
    },
    dealerToken: {
      type: String,
      default: ""
    },
    allDealers: {
      type: Array,
      default: () => []
    },
    employeeData: {
      type: Array,
      default: () => []
    },
    changeKey: {
      type: Number,
      default: 0
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      this.selectedDealer = undefined;
      this.selectedEmployee = undefined;
      this.dealersData = undefined;
      if(newVal){
        this.getDealersForSystem();
      }
    }
  },
  computed:{
    filterDropdownData(){
      if(this.dealersData && this.dealersData.dealers){
        let index = this.dealersData.dealers.findIndex(e => e.authlevel === "1")
        if(index !== -1){
          return this.allDealers.filter(e => e.authlevel == "0");
        } else return this.allDealers
      } else return [];
    }
  },
  mounted() {
    this.authLevel = sessionStorage.authLevel;
    this.userToken = sessionStorage.getItem("userToken");
  },
  
  methods: {
  //  async assignEmployeeToSystem(){
  //   let data = await GlobalService.assignEmployeeToSystem(this.userToken, this.systemData.system.id, this.selectedEmployee.id);
  //   if(data.status === 0){
  //       console.log('All Good');
  //     }else{
  //       console.log(data);
  //     }
  //  },
    async fetchDealerforSystemAfterUpdate(token){
      let DataAfterUpdate = await GlobalService.getBoxesForMap(token);

      if(DataAfterUpdate && DataAfterUpdate.systems && DataAfterUpdate.systems.length){
        this.systemData.system = DataAfterUpdate.systems.find(({system})=>system.id===this.systemData.system.id).system;

        this.systemData.devices = DataAfterUpdate.systems.find(({system})=>system.id===this.systemData.system.id).devices;
      }
    },
    async fetchSystemsData(token) {
      this.fetchDealerforSystemAfterUpdate(this.userToken);
      this.openBoxModal = false;
      this.openReplaceBoxToggle = false;
    },
    async getDealersForSystem() {
      this.systemsData = this.systemData;
      if(this.systemData && this.systemData.system)
        this.dealersData = await GlobalService.getDealersForSystem(this.dealerToken, this.systemData.system.id);
    },
    goToSystem(){
      router.push("/");
    },
    chooseMapPin(status) {
      if (status === "0") {
        return translateFunc("lng_marker_green");
      } else if (status === "1") {
        return translateFunc("lng_marker_red");
      } else {
        return translateFunc("lng_marker_grey");
      }
    },
    async assignDealer(dealer){
      if(dealer && dealer.id){
        let res = await GlobalService.assignDealerToSystem(this.dealerToken, dealer.id, this.systemData.system.id);
        if(res.status === 0){
          this.getDealersForSystem();
        }
      }
    },
    async removeDealer(dealer){
      if(dealer && dealer.id){
        let res = await GlobalService.removeDealerFromSystem(this.dealerToken, dealer.id, this.systemData.system.id);
        if(res.status === 0){
          this.getDealersForSystem();
        }
      }
    },
          ///upate modal//
    closeBoxModalFunct() {
      this.openBoxModal = false;
    },
    openReplaceBoxModal(boxItem, systemId){
      if(boxItem.devicetype === '0'){
        this.replaceBoxTitle= translateFunc("lng_rplce_sewer_box_txt")
      } else if(boxItem.devicetype === '1'){
        this.replaceBoxTitle= translateFunc("lng_rplce_house_box_txt")
      }
      this.addHouseBoxProp = false;
      this.replaceBoxId = boxItem.id;
      this.selectedSystemId = systemId;
      this.openReplaceBoxToggle = true;
      // router.push({name: 'AdminDevices', params: {"replaceBox": true, boxItem, systemId} })
    },
    closeReplaceBoxModalFunc() {
      this.openReplaceBoxToggle = false;
    },
    async getHouseBoxes(system) {
      const data = this.extraHouseBoxes && this.extraHouseBoxes.find(e => e.id == system?.id);

      if(!(data && data.id)){
        let data = await GlobalService.getExtraHouseBoxes(this.userToken, system?.id);
        this.extraHouseBoxes.push({ boxes: data, id: system?.id })
      }
    },
    async refreshHouseBoxes(systemId) {
      const index = this.extraHouseBoxes && this.extraHouseBoxes.findIndex(e => e.id == systemId);
      
      let boxes = await GlobalService.getExtraHouseBoxes(this.userToken, systemId);
      if(index !== -1){
        this.extraHouseBoxes[index].boxes = boxes;
      } else {
        this.extraHouseBoxes.push({ boxes, id: systemId })
      }
    },
    findBoxes(system){
      const data = this.extraHouseBoxes && this.extraHouseBoxes.find(e => e.id == system?.id);
      return data && data.id;
    },
    addNewHouseBox(systemId) {
      this.replaceBoxTitle= translateFunc("lng_add_extra_box_txt")
      this.addHouseBoxProp = true;
      this.replaceBoxId = null;
      this.selectedSystemId = systemId;
      this.openReplaceBoxToggle = true;
    },
    closeUpdateBoxModalFunct() {
      this.openUpdateBoxModal = false;
    },
    openUpdateModal(boxItem) {
      this.addressObj = {
        id: boxItem.id,
        addr1: boxItem.address1,
        addr2: boxItem.address2,
        city: boxItem.city,
        zip: boxItem.zip,
        country: boxItem.country,
        lat: boxItem.geolat,
        lng: boxItem.geolng,
        alarmemail: boxItem.alarmemail,
        serviceemail: boxItem.serviceemail,
        daystillservice: boxItem.daystillservice,
        internalcomment: boxItem.internalcomment,
        operationemail: boxItem.operationemail,
        alarmsms: boxItem.alarmsms,
        alarmprefix: boxItem.alarmprefix,
        mecnumber: boxItem.mecnumber,
        sewertype: boxItem.sewertype,
        uwsequipment: boxItem.uwsequipment,
        servicecontract: boxItem.servicecontract,
        subscription: boxItem.subscription
      };
      this.updateBoxKey += 1;
      this.openUpdateBoxModal = true;
      // router.push({name: 'AdminDevices', params: {"editBox": true, boxItem} })
    },
  }
};
</script>
<style scoped>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
.dropdown-list-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.modal-header {
  position: sticky; 
  top: 0;
  width: 100% !important;
  background: #fff;
  z-index: 9;
  padding: 0 1rem;
}
</style>
